<template>
  <v-flex class="sfh-login-header text-xs-center pa-1">
    <!-- For Sticky top --->
    <v-layout row align-center justify-center style="justify-content: space-between;">
      <div
        class="px-2"
        style="display:flex;"
      >
        <img @click.stop="$store.commit('toggleLeftDrawer', true)"
             height="35"
             width="35"
             :src="levelImage(level)"
             style="cursor:pointer;"
             alt="Level" />
      </div>
      <v-flex >
        <h2  class="white--text font-weight-regular float-left line-height-1"
             style="text-align: left;">
          <span>Quiz</span>
        </h2>
      </v-flex>

      <v-flex xs5 sm4 text-xs-right>

        <v-btn fab color="transparent" @click.stop="$store.commit('toggleRightDrawer', true)"
               class="elevation-0 mr-0" style="width:42px;height:42px;z-index: 1;">
          <div class="user-avatar elevation-10"
               :style="{ backgroundImage: 'url(' + $store.getters['user/avatar'] + ')',height:'40px',width:'40px' }"></div>

        </v-btn>
        <v-toolbar-side-icon             class="ml-0 notranslate"
                                         dark  @click.stop="$store.commit('toggleRightDrawer', true)"
        ></v-toolbar-side-icon>
      </v-flex>
    </v-layout>

    <!--------- Other ---------------->

    <navigation-menu></navigation-menu>

    <v-navigation-drawer
            temporary
            v-model="leftDrawer"
            app
            class="blue-grey darken-4"
    >
      <v-layout row>
        <v-flex>
          <v-card>
            <v-flex class="gutter-mobile-header blue-grey darken-4" />

            <v-list dark class="blue-grey darken-4 pa-0">
              <v-list-tile dark >
                <v-list-tile-action>
                  <v-chip color="blue" text-color="white"
                          label small class="ma-0 pa-0">{{level}} LEVEL</v-chip>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title class="pl-2"><strong>Current Score</strong></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-avatar>
                  {{$store.getters['quiz/getCurrentScorePercent']}}%
                </v-list-tile-avatar>
              </v-list-tile>
            </v-list>

            <v-list dark class="secondary darken-4 pa-0">
              <template v-for="(question, index) in questions">
                <v-list-tile
                        light
                        :key="'question_'+index"
                        ripple
                        active-class="primary"
                        :to="`/quiz/${groupId}/${deckId}/${level}/${index+1}`"
                >
                  <v-list-tile-content>
                    <v-list-tile-title  color="red">{{ question.questionName }}</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action v-if="typeof question.score.scoredValue !== 'undefined'">
                    <!--<v-list-tile-action-text>-->
                    <v-chip small class="font-weight-bold"
                            :style="{color: question.score.scoredValue > 0 ? 'green' : 'red'}">{{question.score.scoredValue}}</v-chip>
                  </v-list-tile-action>

                </v-list-tile>
                <v-divider
                        light
                        v-if="index + 1 < questions.length"
                        :key="index"
                ></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>
    <!--------- Other ---------------->
  </v-flex>

</template>

<script>
  import NavigationMenu from './NavigationMenu'
  import PlainToolbar from './PlainToolbar'

  export default {
    name: 'QuizHeader',
    components: {
      NavigationMenu, PlainToolbar
    },
    data () {
      return {
        groupId: parseInt(this.$route.params.groupId),
        deckId: parseInt(this.$route.params.deckId),
        appIcon: require('@/assets/logos/' + process.env.APP_ICON)
      }
    },
    computed: {
      level () {
        return parseInt(this.$route.params.level)
      },
      step: {
        get: function () {
          return parseInt(this.$route.params.step)
        },
        set: function () {
        }
      },
      leftDrawer: {
        get: function () {
          return this.$store.getters.leftDrawer
        },
        set: function (value) {
          this.$store.commit('toggleLeftDrawer', value)
        }
      },
      questions () {
        return this.$store.getters['quiz/getQuizQuestions']
      }
    },
    created () {
    },
    methods: {
      sfhImage () {
        return `static/images/expander_for_header/expander_level${this.level}.png`
      },
      userImage () {
        return 'static/images/avatar180x.jpg'
      },
      levelImage (levelNumber) {
        return require(`@/assets/images/level_icons/${levelNumber}.svg`)
      }
    },
    watch: {

    }
  }
</script>
<style scoped>
  .left_nav .v-list__group__header .v-list__group__header__prepend-icon{
    display: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/QuizHeader.vue